
import { NgClass, NgIf } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { MiddlemanService } from '../../../../auth/services/Middleman.service';
import * as CryptoJS from 'crypto-js'
const helper = new JwtHelperService();
@Component({
  selector: 'gd-btnviews',
  standalone: true,
  template: `
    <div class="flex flex-wrap gap-2">
      <button
        type="button"
        class="btn"
        [ngClass]="{ 'btn-primary': selectedView === 'all', 'btn-outline': selectedView !== 'all' }"
        (click)="updateSelectedView(['all'])"
      >
        Show All
      </button>
      <button
        *ngIf="showhidebuttons"
        type="button"
        class="btn"
        [ngClass]="{ 'btn-primary': selectedView === 'trading', 'btn-outline': selectedView !== 'trading' }"
        (click)="updateSelectedView(['trading'])"
      >
       Trading-Pending
      </button>
      <button
       *ngIf="showhidetradingbuttons"
        type="button"
        class="btn"
        [ngClass]="{ 'btn-primary': selectedView === 'document', 'btn-outline': selectedView !== 'document' }"
        (click)="updateSelectedView(['document'])"
      >
        Document Review
      </button>
      <button
       *ngIf="showhidetradingbuttons"
        type="button"
        class="btn"
        [ngClass]="{ 'btn-primary': selectedView === 'preliminary', 'btn-outline': selectedView !== 'preliminary' }"
        (click)="updateSelectedView(['preliminary'])"
      >
        Preliminary Review
      </button>
      <button
       *ngIf="showhidetradingbuttons"
        type="button"
        class="btn"
        [ngClass]="{ 'btn-primary': selectedView === 'ins', 'btn-outline': selectedView !== 'ins' }"
        (click)="updateSelectedView(['ins'])"
      >
        Ins Prin Review
      </button>
      <button
        *ngIf="showhidebuttons"
        type="button"
        class="btn"
        [ngClass]="{ 'btn-primary': selectedView === 'jerolyn', 'btn-outline': selectedView !== 'jerolyn' }"
        (click)="updateSelectedView(['jerolyn'])"
      >
        Principal Review
      </button>
      <button
        *ngIf="showhidebuttons"
        type="button"
        class="btn"
        [ngClass]="{ 'btn-primary': selectedView === 'ron', 'btn-outline': selectedView !== 'ron' }"
        (click)="updateSelectedView(['ron'])"
      >
        529/ALT Review
      </button>

    </div>
  `,
  styleUrls: ['./btnviews.component.css'],
  imports: [NgIf, NgClass]
})
export class BtnviewsComponent implements OnInit, OnDestroy {
  @Input() selectedView: string;
  @Output() viewEmitter = new EventEmitter<string>();
  public showhidebuttons: boolean | false;
  public showhidetradingbuttons: boolean | false;
  private subscription: Subscription;
  private roleName: string;
  private username: string;
  private authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;

  constructor(private _nextclear: MiddlemanService) {
    this.subscription = this._nextclear.notifyredirectObservable$.subscribe((res) => {
      if (res) {
        const getrightsideofsplit = res.split('|');
          this.showhidebuttons = false;
        this.showhidetradingbuttons = false;
        this.setButtonVisibility(getrightsideofsplit[1]);
      }
    });
    // Get username from token
    this.username = this.getUsernameFromToken();
  }

  ngOnInit(): void {
    const changevalue = localStorage.getItem('rrolelisted')
    const paramRoleFirstTN = CryptoJS.AES.decrypt(
      changevalue,
      environment.securepw,
    ).toString(CryptoJS.enc.Utf8)
    const storedRole = paramRoleFirstTN
    if (storedRole) {
      this.setButtonVisibility(decodeURIComponent(storedRole));
    }
  }

  setButtonVisibility(role: string) {
    this.roleName = role;
    if (role !== '') {
      if ((role === 'COMPLIANCE USER') || (role === 'INSURANCE PRINCIPAL') || (role === 'INSURANCE USER') || (role === 'DOCUMENT REVIEWER')) {
        this.showhidebuttons = false;
        this.showhidetradingbuttons = true;
        sessionStorage.setItem('btnsetting', 'true');
      } else if ((role === 'TRADING USER') || (role === 'TRADING PRINCIPAL') || (role === 'COMPLIANCE PRINCIPAL') || (role === 'ADVISOR PRINCIPAL')) {
        this.showhidetradingbuttons = false;
        this.showhidebuttons = true;
        sessionStorage.setItem('btnsetting', 'true'); 
       } else if (role === 'REP') {
        this.showhidetradingbuttons = false;
        this.showhidebuttons = false;
        sessionStorage.setItem('btnsetting', 'true');
      } else {
        this.showhidebuttons = true;
        this.showhidetradingbuttons = true;
        sessionStorage.removeItem('btnsetting');
      }
    }
    
    // Don't load saved preference - parent component (pending) now manages state via PendingTransactionViewState
    // This prevents overriding the parent's state on page refresh
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  updateSelectedView(view: string[]) {
    this.viewEmitter.emit(view[0]);
    this.saveViewPreference(view[0]);
  }

  private getUsernameFromToken(): string {
    try {
      const tokenData = localStorage.getItem(this.authLocalStorageToken);
      if (tokenData) {
        const parsed = JSON.parse(tokenData);
        const token = parsed?.token;
        if (token) {
          const decoded = helper.decodeToken(token);
          // Use the standard .NET claim for username
          return decoded?.['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'] || 'anonymous';
        }
      }
    } catch (error) {
      console.error('Error parsing token:', error);
    }
    return 'anonymous';
  }

  private getViewPreferenceKey(): string {
    return `${environment.appVersion}_pendingView_${this.username}_${this.roleName}`;
  }

  private saveViewPreference(view: string): void {
    if (this.username && this.roleName) {
      const storageKey = this.getViewPreferenceKey();
      //sessionStorage.setItem(storageKey, view);
      localStorage.setItem(storageKey, view);
    }
  }

  public loadViewPreference(): string | null {
    if (this.username && this.roleName) {
      const storageKey = this.getViewPreferenceKey();
        localStorage.getItem(storageKey);
      return  localStorage.getItem(storageKey); //sessionStorage.getItem(storageKey);
    }
    return null;
  }
}
